// extracted by mini-css-extract-plugin
module.exports = {"box":"alert_box__2W6zB","box_active":"alert_box_active__2U_De","box__content":"alert_box__content__fZH7y"};